import type { NeverCreated } from "./destructive-confirmation.ts"

/*
 * What a Composer says of the thing it makes, kept apart from the dialog so it can be checked
 * without a browser.
 */

/** What a Composer makes: a ticket, an Epic, a Project or a Chat channel. */
export type Made = "ticket" | "epic" | "project" | "channel"

const made = {
  ticket: { label: "New ticket", discards: "new-ticket" },
  epic: { label: "New Epic", discards: "new-epic" },
  project: { label: "New Project", discards: "new-project" },
  channel: { label: "New channel", discards: "new-channel" },
} as const satisfies Record<Made, { label: string; discards: NeverCreated }>

/**
 * The crumb's label for what a Composer makes ("New Epic"), and what its Discard question discards:
 * the new thing, never created, which asks "Discard this Epic?".
 */
export const composedOf = (makes: Made) => made[makes]
